import React, { useEffect, useState } from "react";
import { Card, CardHeader, ListGroup, ListGroupItem, Row, Col, Form, FormGroup, FormInput, FormSelect, FormTextarea, Button, Alert } from "shards-react";
import { Store } from "../flux";

const AppDetails = props => {

    const [ Details, SetDetails ] = useState({});
    const [ ShowAlert, SetShowAlert ] = useState(false);

    useEffect(() => {

        SetDetails(props.App);
    }, [ props.App ]);

    const updateApp = async () => {

        const UpdateData = JSON.stringify(Details);
        await fetch("https://app-centre.tascomi.com/app-centre.php?end_point=update_app_details&data=" + UpdateData);
        await Store.retrieveApps();

        await SetShowAlert(true);

        setTimeout(() => {

            SetShowAlert(false);
        }, 2000);
    }

	return (
		<Card small className="mb-4">
			<CardHeader className="border-bottom">
				<h6 className="m-0">App Details</h6>
			</CardHeader>

			<ListGroup flush>
				<ListGroupItem className="p-3">
					<Row>
						<Col>
							<Form>
								<Row form>

									{/* App Name */}
									<Col md="6" className="form-group">
										<label htmlFor="name">Name</label>
										<FormInput id="name" placeholder="App Name" value={ Details.name } onChange={ (e) => { props.Change(e.target.value, e.target.id)} } />
									</Col>

									{/* Unique App Name */}
									<Col md="6" className="form-group">
										<label htmlFor="unqiue_app_name">Unique App Name</label>
										<FormInput id="unqiue_app_name" placeholder="Unique App Name" value={ Details.unique_app_name } onChange={ (e) => { props.Change(e.target.value, e.target.id)} } />
									</Col>
								</Row>

								<Row form>

									{/* System Name */}
									<Col md="6" className="form-group">
										<label htmlFor="system_name">System Name</label>
										<FormInput id="system_name" placeholder="System Name" value={ Details.system_name } onChange={ (e) => { props.Change(e.target.value, e.target.id)} } />
									</Col>
								</Row>

								<Row form>

									{/* App Description */}
									<Col md="12" className="form-group">
										<label htmlFor="description">Description</label>
										<FormTextarea id="description" rows="5" value={ Details.description } onChange={ (e) => { props.Change(e.target.value, e.target.id)} } />
									</Col>
								</Row>

								<Button theme="accent" onClick={ updateApp }>Update App</Button>

                                { ShowAlert &&
                                    <>
                                        <br /><br />
                                        <Alert className="alert-success alert-dismissible fade show mb-0" role="alert">
                                            <i className="fa fa-check mx-2"></i>
                                            <strong>Success!</strong> { props.App.name } has been updated.
                                        </Alert>
                                    </>
                                }
							</Form>
						</Col>
					</Row>
				</ListGroupItem>
			</ListGroup>
		</Card>
	);
}

export default AppDetails;
